/**
 * Vendor library imports — replaces Grunt uglify (LibraryScripts.js).
 *
 * npm packages are imported as ES modules. A few local scripts that
 * have no npm equivalent (Google Maps utilities, Modernizr) are
 * still loaded via `?raw` + `execGlobal`.
 */

// ── npm packages ────────────────────────────────────────────────────────

import Mousetrap from 'mousetrap';
(window as any).Mousetrap = Mousetrap;

import moment from 'moment';
(window as any).moment = moment;

// moment plugins — v2.x setup function avoids CJS require('moment')
// resolution issues in Vite dev mode
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment);
import 'moment-timezone';

// ── execGlobal helper (kept for scripts without npm packages) ───────────

/**
 * Execute JS source text in the global scope (sloppy mode) by injecting
 * a <script> element. This ensures UMD/IIFE patterns that use
 * `this === window` or unqualified `var` declarations register globals
 * correctly, unlike `eval()` or `new Function()` in strict-mode contexts.
 */
function execGlobal(source: string) {
  const script = document.createElement('script');
  script.textContent = source;
  document.head.appendChild(script);
  document.head.removeChild(script);
}

// ── Version globals (previously in tsconfig files[]) ──────────────────
import ornaVersionRaw from '../Content/orna-version.js?raw';
execGlobal(ornaVersionRaw);
import ornaBackendVersionRaw from '../Content/orna-backend-version.js?raw';
execGlobal(ornaBackendVersionRaw);

// ── Local Scripts (via ?raw) — no npm equivalents ──────────────────────

import overlappingSpiderfierRaw from '../Scripts/OverlappingMarkerSpiderfier.js?raw';
execGlobal(overlappingSpiderfierRaw);

// maplabel.js requires google.maps — OK since Maps <script> loads first
import maplabelRaw from '../Scripts/maplabel.js?raw';
execGlobal(maplabelRaw);

